<template>
  <nav class="navbar navbar-default" role="navigation">
    <div>
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target="#myNavbar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <router-link to="/Home" tag="a" class="navbar-brand">
          <img class="logo" src="@/assets/logo-child-care.svg" />
        </router-link>
      </div>

      <div class="collapse navbar-collapse" id="myNavbar">
        <div class="navbar-form navbar-left">
          <div class="row">
            <div class="col-md-9">
              <div class="form-group">
                <DxSelectBox
                  :search-enabled="true"
                  :data-source="organizations"
                  search-mode="contains"
                  :search-expr="['Description', 'Afm']"
                  :search-timeout="200"
                  :min-search-length="2"
                  :show-data-before-search="true"
                  display-expr="Description"
                  value-expr="Id"
                  v-model="selectedOrganizationId"
                  @value-changed="setSelectedOrganization"
                  placeholder="Επιλέξτε Φορέα"
                  :show-clear-button="false"
                  width="300px"
                />
              </div>
            </div>
            <div class="col-md-3">
              <DxButton
                id="info"
                icon="info"
                @click="showOrganizationInfo"
                :hint="organizationDesc"
              />
            </div>
          </div>
        </div>

        <ul class="nav navbar-nav navbar-right">
          <li>
            <a href="#" @click="showHelp">Βοήθεια</a>
          </li>
          <li v-if="isSuperAdmin">
            <a href="#" @click="editHelp">Επεξ.Βοήθειας</a>
          </li>
          <li>
            <a href="#" @click="showUserInfo">
              <b>Χρήστης {{ nickName }}</b></a
            >
          </li>

          <li v-if="isAuthenticated">
            <a href="#" @click="onLogout">Έξοδος</a>
          </li>
        </ul>

        <!-- <div class="navbar-right"><img src="@/assets/eeta-logo.svg" alt="" style="max-height:60px;"></div> -->
      </div>
    </div>
    <DxToast
      :visible="showErrorNotification"
      :message="errorMessage"
      type="error"
      @hiding="onHiding"
    />
    <helpEdit
      v-if="editHelpPopupIsVisible && isSuperAdmin"
      :isVisible="editHelpPopupIsVisible && isSuperAdmin"
      :pageName="pageRoute"
      v-on:emit-close-popup="HidePopup"
    />
    <helpShow
      v-if="showHelpPopupIsVisible"
      :isVisible="showHelpPopupIsVisible"
      :pageName="pageRoute"
      v-on:emit-close-popup="HidePopup"
    />
  </nav>
</template>

<script>
import { DxButton } from "devextreme-vue/button";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxToast } from "devextreme-vue/toast";
import helpEdit from "../help/helpEdit";
import helpShow from "../help/helpView";

export default {
  components: {
    DxButton,
    DxSelectBox,
    helpEdit,
    helpShow,
    DxToast,
  },
  data() {
    return {
      organizations: [],
      //selectedOrganizationId: null,
      pageRoute: "",
      editHelpPopupIsVisible: false,
      showHelpPopupIsVisible: false,
      errorMessage: "",
      showErrorNotification: false,
      tooltipVisible: false,
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    nickName() {
      return this.$store.getters.getNickName;
    },
    selectedOrganizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    organizationDesc() {
      if (this.selectedOrganizationId != null)
        var organization = this.organizations.find(
          (x) => x.Id == this.selectedOrganizationId
        );
      if (organization != null) return organization.Description;

      return "";
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
    },
    setSelectedOrganization(e) {
      this.$store.dispatch("setSelectedOrganizationId", e.value);
      //this.selectedOrganizationId = e.value;
    },
    showOrganizationInfo() {
      this.$router.push(`/organization/${this.selectedOrganizationId}`);
      this.$route.params.pathMatch;
    },
    showUserInfo() {
      this.$router.push(`/user`);
    },
    editHelp() {
      this.editHelpPopupIsVisible = true;
      this.pageRoute = this.$route.path;
    },
    showHelp() {
      this.showHelpPopupIsVisible = true;
      this.pageRoute = this.$route.path;
    },
    HidePopup() {
      this.editHelpPopupIsVisible = false;
      this.showHelpPopupIsVisible = false;
    },
    onHiding(e) {
      if (this.showErrorNotification) e.cancel = true;
    },
    toggleTooltip() {
      this.tooltipVisible = !this.tooltipVisible;
    },
  },
  watch: {
    selectedOrganizationId: async function (newValue, oldValue) {
      if (
        this.selectedOrganizationId == null ||
        isNaN(this.selectedOrganizationId)
      ) {
        this.errorMessage = "Δεν έχετε επιλέξει Φορέα!";
        this.showErrorNotification = true;
        return;
      } else {
        this.showErrorNotification = false;
      }
    },
  },
  created() {
    this.organizations = this.$store.getters.getOrganizations;
    //this.selectedOrganizationId = this.$store.getters.getSelectedOrganizationId;
  },
  mounted() {
    if (
      this.selectedOrganizationId == null ||
      isNaN(this.selectedOrganizationId)
    ) {
      this.errorMessage = "Δεν έχετε επιλέξει Φορέα!";
      this.showErrorNotification = true;
      return;
    }
  },
};
</script>


<style lang="scss" scoped>
.navbar-right {
  margin-right: 0 !important;
}
li a {
  text-decoration: none;
  color: black !important;
  text-transform: uppercase;
  font-size: 0.9rem;
}

li a:hover,
li a:active,
li a.router-link-active {
  color: #fa923f !important;
}
.logo {
  width: 150px;
  margin-top: -11px;
}
.logout {
  background-color: transparent;
  border: none;
  font: inherit;
  color: white;
  cursor: pointer;
}

.nav > li > a {
  padding: 0 4px;
  line-height: 55px;
}
</style>